import { Api } from '@axiom/ui';
import type { AfcSubmission } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class SubmissionsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readSubmissionDetails(submissionId: AfcSubmission['submissionId']) {
    return super.read<{ data?: AfcSubmission }>({
      endpoint: `/submissions/${submissionId}`,
      method: 'GET',
    });
  }

  async refreshSubmissionDetails(submissionId: AfcSubmission['submissionId']) {
    return super.invalidate(`/submissions/${submissionId}`);
  }
}

export const SubmissionApi = new SubmissionsApiClass();
